import React, { useState } from "react";
import { Card, Row, Col, Typography, Button, Divider, Image, Modal } from "antd";
import styles from "./Style.module.less";
import { useTranslate } from "../../../Translate";
import {
  DeleteOutlined,
  LoginOutlined,
  SettingOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
const { Title, Paragraph } = Typography;


const statoApp = {
  "ABILITATO": 'Abilitato',
  "IN_ATTIVAZIONE": 'In attivazione',
  "SOSPESO": 'Sospeso',
  "SOSPESO_DA_ADMIN": 'Sospeso da admin',
  "CESSATA": 'Cessata',
  "SCADUTA": 'Scaduta'

};

const CardStore = (props) => {
  const {
    handleDetail,
    app,
    tipo,
    handleDeleteApp,
    handleGoApp,
    handleSettingApp,
    isManagement_app,
  } = props;
  let strigcat = "";
  app?.categorie?.map((item, index) => {
    if (index > 0) strigcat += ", ";
    strigcat += item.descrizione;
    return item;
  });
  const [expanded, setExpanded] = useState(false);
  const [showPurchaseHistory, setShowPurchaseHistory] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;
  const onClick = () => {
    handleDetail(app.id);
  };
  //console.log(isManagement_app+":::"+app.id+":::"+app.maxUtenti);
  //console.log(app)
  // const [ellipsis, setEllipsis] = useState(true);
  var scaduta = app?.abilitazione ==='SCADUTA' ? true : false; 
  const actionsMyApps = [
    !scaduta ? <SettingOutlined
      onClick={() =>
        isManagement_app && app.maxUtenti !== 0 && statoApp[app.abilitazione] ==='Abilitato' ? handleSettingApp(app) : false
      }
      title="Impostazioni APP"
      key="setting"
      className={
        (isManagement_app && app.maxUtenti !== 0 && statoApp[app.abilitazione] ==='Abilitato')
          ? styles.enabled
          : styles.disabled
      }
      style={{ fontSize: 20 }}
    />: null,
    <DeleteOutlined
      onClick={() => (isManagement_app && app?.pricingAttivazione !== 4 ? handleDeleteApp(app) : false)}
      title="Cancella APP"
      className={isManagement_app && app?.pricingAttivazione !== 4 ? styles.enabled : styles.disabled}
      key="delete"
      //   style={{ fontSize: 20 }}
    />,
    !scaduta ? <LoginOutlined
      onClick={() =>
        (app.maxUtenti === 0 || app.userCanUseApp) && app.abilitazione ==='ABILITATO'  ? handleGoApp(app) : false
      }
      title="Accedi"
      key="login"
      className={
        (app.maxUtenti === 0 || app.userCanUseApp) && app.abilitazione ==='ABILITATO'
          ? styles.enabled
          : styles.disabled
      }
      style={{ fontSize: 20 }}
    />: null,
  ];
  const actionMyFavorites = [];
  const actions =
    tipo === "view_myapps"
      ? actionsMyApps
      : tipo === "view_favorites"
      ? actionMyFavorites
      : [];

  const skeleton =
    "data:image/jpeg;base64,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";

  const handleExpand = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <Card
        actions={actions}
        style={{
          width: 350,
          boxShadow: "5px 8px 24px 5px rgba(171, 171, 171, 0.6)",
          borderRadius: "5px",
        }}
        cover={
          <Image
            preview={false}
            width={350}
            height={350}
            src={app.iconaPreview ? app.iconaPreview : skeleton}
          />
        }
      >
        <Row>
          <Col span={24}>
            <Title
              level={4}
              style={{
                color: "#8c8b8b",
                textAlign: "left",
                border: "0px solid",
              }}
            >
              <Paragraph
                ellipsis={{ rows: 2, expandable: false }}
                style={{
                  WebkitLineClamp: 2,
                  display: "-webkit-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  border: "0px solid",
                  height: "60px",
                }}
              >
                {app.titolo}
              </Paragraph>
              {/* <span onClick={() => {setEllipsis(!ellipsis)}} style={{color:'#E31E1E', fontSize:'12px'}}>{ellipsis ? t("more"): t("less")}</span> */}
            </Title>
            <Divider />
            <div className={styles.additional}>
              <p>
                <b>{t("author")}:</b> <span>{app.autore}</span>
              </p>
              <p>
                <b>{t("activationdate")}:</b>{" "}
                <span className="data">
                  {app.dataPubblicazione != null
                    ? new Intl.DateTimeFormat("it-IT", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }).format(new Date(app.dataPubblicazione))
                    : ""}
                </span>
              </p>
              {tipo === "view_myapps" || tipo === "view_favorites" ? (
                <p>
                  <b>{t("datebuy")}:</b>{" "}
                  <span className="data">
                    {app.datiAcquisto?.dataAcquisto != null
                      ? new Intl.DateTimeFormat("it-IT", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        }).format(new Date(app.datiAcquisto.dataAcquisto))
                      : ""}
                  </span>
                </p>
              ) : (
                ""
              )}
              {tipo === "view_myapps" || tipo === "view_favorites" ? (
                <p>
                  <b>{t("group")}:</b>{" "}
                  <span>{app.companyName !== null ? app.companyName : ""}</span>
                </p>
              ) : (
                ""
              )}
              {tipo === "view_myapps" || tipo === "view_favorites" ? (
                <p>
                  <b>{t("state")}:</b>{" "}
                  <span style={{color:'#e61e1e'}}>{app.abilitazione !== null ? statoApp[app.abilitazione] : ""}</span>
                </p>
              ) : (
                ""
              )}
              {app?.pricingAttivazione === 4 && tipo == "view_myapps" ? (
                <p>
                  <b>Numero di acquisti:</b>{" "}
                  <span
                    onClick={() => setShowPurchaseHistory(true)}
                    style={{ cursor: "pointer", color: "#e61e1e", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  >
                    {app.purchaseCount || 0}
                    <HistoryOutlined style={{ fontSize: "14px" }} />
                  </span>
                </p>
              ) : (
                ""
              )}
              <p>
                <b>{t("availableon")}:</b>{" "}
                <span className="active">
                  {app.disponibileWeb ? "WEB" : ""}
                  {app.disponibileWeb && app.disponibileMFP ? " - " : ""}
                  {app.disponibileMFP ? "MFP" : ""}
                </span>
              </p>
              <p>
                <b>{t("category")}:</b>{" "}
                <span className="active">{strigcat}</span>
              </p>
              <br></br>

              <p style={{ textAlign: "center" }}>
                {tipo === "view_myapps" || tipo === "view_favorites" ? (
                  ""
                ) : (
                  <Button
                    size="large"
                    style={{ width: "150px" }}
                    onClick={onClick}
                    danger
                  >
                    {t("details")}
                  </Button>
                )}
              </p>
            </div>
          </Col>
        </Row>
      </Card>
      <Modal
        title="Acquisti precedenti"
        open={showPurchaseHistory}
        onOk={() => setShowPurchaseHistory(false)}
        onCancel={() => setShowPurchaseHistory(false)}
        okText="Chiudi"
        cancelText={null}
      >
        {app?.otherInstances && app.otherInstances.length > 0 ? (
          <ul>
            {app.otherInstances.map((instance, index) => (
              <li key={index}>
                {instance.datiAcquisto?.dataAcquisto
                  ? new Intl.DateTimeFormat("it-IT", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }).format(new Date(instance.datiAcquisto.dataAcquisto))
                  : "Data non disponibile"}
              </li>
            ))}
          </ul>
        ) : (
          <p>Nessun acquisto precedente</p>
        )}
      </Modal>
    </>
  );
};

export default CardStore;
